<h2>Channel Details</h2>
<ag-grid-angular 
	style="width: auto; height: auto; margin: 20px 0px;" 
	class="ag-theme-balham"
	[gridOptions]="gridOptions"
	[rowData]="resRevByDay" 
	(gridReady)="onGridReady($event)"
	(firstDataRendered)="onFirstDataRendered($event)"
    (rowGroupOpened)="onRowGroupOpened($event)"
>
</ag-grid-angular>

<br>
<br>

<ag-grid-angular 
	style="width: auto; height: auto; margin: 20px 0px;" 
	class="ag-theme-balham"
	[gridOptions]="gridOptions2"
	[rowData]="resRevByDay" 
	(gridReady)="onGridReady($event)"
	(firstDataRendered)="onFirstDataRendered($event)"
	[pivotMode]="true"
	(rowGroupOpened)="onRowGroupOpened($event)"
>
</ag-grid-angular>